import { AxisRenderer, CategoryAxis } from '@amcharts/amcharts5/xy';

import { getTotalFrameCountPerDimension } from 'features/Health/components/FrameHealthChart/utils/axisLabel/getTotalFrameCountPerDimension';
import { FrameHealthDimension } from 'features/Health/containers/FrameHealthChartContainer/types/frameHealthDimension';

const labelText = (totals: Map<String, number>, data: FrameHealthDimension) =>
  `${data.dimension} [bold](${totals.get(data.dimension)})`;

export const setYAxisLabel = (
  yAxis: CategoryAxis<AxisRenderer>,
  chartData: FrameHealthDimension[]
) => {
  const totals: Map<String, number> = getTotalFrameCountPerDimension(chartData);

  yAxis.get('renderer').labels.template.events.on('dataitemchanged', (event) => {
    const data = event.newDataItem?.dataContext as FrameHealthDimension;
    event.target.set('text', labelText(totals, data));
  });
};
